import { map } from "lodash";
import * as Yup from "yup";

import { EventCode } from "../../types";
import { getLuxonDateTime, getToday } from "../../utils/dateFormatter";
import {
  dateValidation,
  isFirstDateAfterSecondDate,
} from "../../utils/yupValidation";
import { CreateCallFormValues } from "./types";

const createCallFormSchema: Yup.SchemaOf<CreateCallFormValues> =
  Yup.object().shape({
    callType: Yup.mixed<EventCode>()
      .oneOf(map(EventCode))
      .default(EventCode.Null)
      .test({
        message: () => "Required",
        test: function (value) {
          return value !== EventCode.Null;
        },
      }),
    callAmountDisplay: Yup.string()
      .max(16, "Maximum 16 characters")
      .required("Required")
      .default(""),
    callAmountRaw: Yup.number().min(0.01, "Minimum amount: 0.01"),
    tradeDate: dateValidation()
      .test("future trade date test", "Cannot be future date", isFutureDate)
      .required("Required"),
    issueDate: dateValidation()
      .test("future issue date test", "Cannot be future date", isFutureDate)
      .required("Required"),
    dueDate: dateValidation()
      .test(
        "date compare",
        "Must be greater than or equal to issue date",
        (value, context) =>
          isFirstDateAfterSecondDate(value, context.parent.issueDate)
      )
      .required("Required"),
  });

export default createCallFormSchema;

function isFutureDate(date?: string | Date) {
  if (!date) return true;
  const formattedDate = getLuxonDateTime(date);
  const today = getLuxonDateTime(getToday());

  if (formattedDate && today && formattedDate > today) {
    return false;
  }
  return true;
}
